export default {
    cheatsheet: {
        title: "Wettschein",
        empty: {
            noPlaysAvailable: "Keine Plays verfügbar",
        },
        separators: {
            noLongerPerfect: "Darunter nicht mehr 100%",
        },
        generate: {
            homeRow: "Deinen Wettschein erstellen",
            results: {
                title: "Deine Cheatsheet",
                subtitle: "Erstellt",
            },
            actions: {
                generate: "Erstellen",
            },
            options: {
                all: "Alle",
            },
            empty: {
                title: "Keine Props gefunden",
                subtitle: "Ändere deine Auswahl, um mehr Props zu finden.",
                action: "Auswahl anpassen",
            },
            outcome: {
                title: "Wonach suchst du?",
                subtitle: "Wähle Over oder Under.",
                over: "Over",
                under: "Under",
            },
            propType: {
                title: "Was bevorzugst du?",
                subtitle: "Wähle Spieler- oder Team-Props.",
                player: "Spieler-Props",
                team: "Team-Props",
            },
            lineType: {
                title: "Welche Linien möchtest du?",
                subtitle: "Wähle Haupt- oder Alternativlinien.",
                main: "Hauptlinien",
                alternate: "Alternativlinien",
            },
            cheatsheetType: {
                title: "Worauf sollen wir es basieren?",
                subtitle: "Wähle den Zeitraum als Grundlage.",
                recentForm: "Aktuelle Form",
                versusOpponent: "Gegen Gegner",
                homeAwaySplits: "Heim/Auswärts",
            },
            games: {
                title: "Welche Spiele einbeziehen?",
                subtitle: "Beziehe alle Spiele ein oder wähle bestimmte aus.",
            },
            betTypes: {
                title: "Welche Props möchtest du?",
                subtitle: "Wähle die Wettarten, die du einbeziehen möchtest.",
            },
            operators: {
                title: "Wo sollen wir suchen?",
                subtitle: "Wähle die Quoten, die du einbeziehen möchtest.",
            },
            loader: {
                prefix: "Prüfe",
                ready: "Wettschein bereit",
                accessibilityLabel: "Dein Wettschein wird erstellt",
                values: {
                    overs: "Overs...",
                    unders: "Unders...",
                    mainLines: "Hauptlinien...",
                    alternateLines: "Alternativlinien...",
                    recentForm: "Aktuelle Form...",
                    versusOpponent: "Gegen Gegner...",
                    homeAwaySplits: "Heim/Auswärts...",
                    todaysGames: "Heutige Spiele...",
                    selectedGames: "{{count}} ausgewählte(s) Spiel(e)...",
                    allBetTypes: "Alle Wettarten...",
                    oneBetType: "{{name}}...",
                    twoBetTypes: "{{first}} und {{second}}...",
                    manyBetTypes: "{{count}} Wettarten...",
                    yourSportsbooks: "Deine Sportsbooks...",
                    allSportsbooks: "Alle Sportsbooks...",
                    specificSportsbooks: "{{count}} Sportsbook(s)...",
                    building: "Deine Cheatsheet wird erstellt...",
                },
            },
        },
    },
};
